// File: presse/types/PresseImageOnly.jsx
import React from "react";
import PresseHeader from "../PresseHeader";

export default function PresseImageOnly({ presse, isActive, toggle, BASE_URL }) {
  const imageMedia = (Array.isArray(presse.media) ? presse.media : []).filter((file) =>
    String(file?.type || "").toLowerCase().includes("image")
  );

  const primaryImage = [...imageMedia].sort((a, b) => {
    const da = Date.parse(a?.createdAt || "") || 0;
    const db = Date.parse(b?.createdAt || "") || 0;
    if (db !== da) return db - da;
    return (Number(b?.id) || 0) - (Number(a?.id) || 0);
  })[0];

  return (
    <div className="presse__message presse__message--image-only">

      <div className="presse__message__media__grid">
        {primaryImage && (
          <img
            key={primaryImage.id}
            src={primaryImage.path}
            alt={primaryImage.filename || presse.title || ""}
            className="presse__message__media__img"
            onError={(e) => { e.currentTarget.style.display = 'none'; }}
          />
        )}
      </div>

      <div
        className={`presse__message__textbar ${isActive(presse.id) ? "presse__message__textbar--below" : ""}`}
        onClick={() => toggle(presse.id)}
      >
        <PresseHeader presse={presse} />
      </div>

      {isActive(presse.id) && (
        <p className="presse__message__content">{presse.content}</p>
      )}
    </div>
  );
}
